import { object } from 'yup'

const ConditionalObjectRequirement = (conditionalFieldKey, conditionalFieldValue, conditionalSchema) => object().when(conditionalFieldKey, {
  is: conditionalFieldValue,
  then: conditionalSchema,
  otherwise: object().notRequired()
})

export default ConditionalObjectRequirement
